module.exports = __webpack_public_path__ + "img/top1.5c196a14.png";